import PubSub from 'pubsub-js';
import { gsap, Power2 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const isSafari = navigator.vendor
  && navigator.vendor.indexOf('Apple') > -1
  && navigator.userAgent
  && navigator.userAgent.indexOf('CriOS') == -1
  && navigator.userAgent.indexOf('FxiOS') == -1;

const transition = {
  colors: [
    '#f2f2f2'
  ],
  init() {
    console.log('Initializing transitions...');
    this.$el = document.getElementById('transition');
    this.ctx = this.$el.getContext('2d');
    this.setUpListeners();
  },

  setUpListeners() {
    window.onpopstate = () => {
      this.navigateTo(document.location);
    };

    document.addEventListener('click', this.clickHandler.bind(this));
    window.addEventListener('resize', this.resizeHandler.bind(this));
    this.resizeHandler();
  },

  resizeHandler() {
    this.$el.width = this.wWidth;
    this.$el.height = this.wHeight;
  },

  clickHandler(ev) {
    const $link = ev.target.closest('a');
    const $switcher = ev.target.closest('.language_switcher');

    if ($switcher !== null) {
      document.cookie = 'language_override=true; expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;domain=.naturaldiamonds.com'/* eslint-disable-line */
    } else if ($link !== null && !this.isExternal($link.href)) {
      if ($link.href === location.href) {
        return;
      } else {
        ev.preventDefault();
      }

      if ($link.closest('.watch_film') !== null) {
        this.needsToPlayTheVideo = true;
      }

      window.history && history.pushState({}, '', $link.href);
      this.navigateTo($link.href);
    }
  },

  navigateTo(url) {
    PubSub.publish('page.transitionStart');

    this.color = this.colors[Math.floor(this.colors.length * Math.random())];

    Promise.all([this.makeRequest(url, 'document'), this.animateIn()])
      .then((res) => {
        const $newDoc = res[0].response;
        const $header = $newDoc.querySelector('.main_header');
        const $newMain = $newDoc.querySelector('main');

        PubSub.publish('page.transitionMiddle');

        document.title = $newDoc.querySelector('head > title').textContent;
        document.querySelector('#app > main').replaceWith($newMain);
        document.documentElement.scrollTop = 0;

        PubSub.publish('header.updateMenuItems', $header);
        PubSub.publish('header.toggleColor');
        PubSub.publish('header.closeMenu');

        let scriptsToEval = '';
        $newMain.querySelectorAll('script')
          .forEach($script => {
            const type = $script.getAttribute('type');
            const src = $script.getAttribute('src');
            const code = $script.textContent.trim();

            if ((!type || type === 'text/javascript') && code) {
              scriptsToEval += code + ';\n';
            }
          });

        this.evalScripts(scriptsToEval);

        PubSub.publish('page.inDOM');

        if (isSafari) {
          console.log('Fixing safari object-fit bug...');

          $newMain.querySelectorAll('picture.image > img')
            .forEach($img => {
              // force images to render again
              const srcset = $img.getAttribute('srcset');
              $img.setAttribute('srcset', '');
              $img.setAttribute('srcset', srcset);
            });
        }

        // HOTFIX: force ScrollTrigger to check the new BG as soon
        setTimeout(function () {
          window.scrollTo(0, 1);

          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 10);
        }, 10);

        this.animateOut().then(() => {
          PubSub.publish('page.transitionEnd');
          ScrollTrigger.refresh();

          if (this.needsToPlayTheVideo) {
            PubSub.publish('header.playTheVideo');
          }
        });
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error('Something went wrong: ', error);

        window.location.href = url;
      });
  },

  animateIn() {
    const trVars = {
      progress: 0
    };
    const $appContainer = document.getElementById('app');

    this.$el.classList.add('active');

    return new Promise(resolve => {
      const tl = gsap.timeline({
        onComplete() {
          $appContainer.style.transform = 'none';

          resolve();
        },
        callbackScope: this,
        defaults: {
          duration: 0.7,
          ease: 'power2.inOut'
        }
      });

      tl.to(trVars, {
        progress: 1,
        onUpdate() {
          // must use the pre-processed(linear) progress
          let leadProgress = this.mapRange(tl.progress(), 0, 0.95, 0, 1, 1);
          leadProgress = Power2.easeInOut(leadProgress);

          $appContainer
            .style.transform = 'translateY(' + (trVars.progress * 1.5) + 'rem)';

          this.ctx.save();
          // this.ctx.globalAlpha = trVars.progress
          this.ctx.clearRect(0, 0, this.wWidth, this.wHeight);
          // this.ctx.fillStyle = '#00c1de';
          // this.ctx.fillRect(0, 0, this.wWidth, this.wHeight * leadProgress);
          this.ctx.fillStyle = this.color;
          this.ctx.fillRect(0, 0, this.wWidth, this.wHeight * trVars.progress);
          this.ctx.restore();
        },

        callbackScope: this
      });

      // tl.to(document.querySelectorAll('#app > *'), {
      //   y: this.currRootSize * 0.4,
      //   duration: 0.8,
      //   ease: 'power2.inOut'
      // }, 0);
    });
  },

  animateOut() {
    const trVars = {
      progress: 1
    };

    // prepare for the transition-out
    // gsap.set(document.querySelectorAll('#app > *'), {
    //   y: this.currRootSize * -0.4
    // }, 0);

    return new Promise(resolve => {
      const tl = gsap.timeline({
        onComplete() {
          this.$el.classList.remove('active');
          resolve();
        },

        callbackScope: this,

        defaults: {
          duration: 0.7,
          ease: 'power3.inOut'
        }
      });

      tl.to(trVars, {
        progress: 0,
        onUpdate() {
          const leadProgress = this.mapRange(trVars.progress, 0.8, 0, 1, 0, 1);
          const newHeight = trVars.progress * this.wHeight;
          const leadHeight = leadProgress * this.wHeight;

          this.ctx.save();
          this.ctx.globalAlpha = 1;
          this.ctx.clearRect(0, 0, this.wWidth, this.wHeight);
          // this.ctx.fillStyle = '#00c1de';
          // this.ctx.fillRect(
          //   0, this.wHeight - leadHeight,
          //   this.wWidth, leadHeight
          // );
          this.ctx.fillStyle = this.color;
          this.ctx.fillRect(
            0, this.wHeight - newHeight,
            this.wWidth, newHeight
          );
          this.ctx.restore();
        },

        callbackScope: this
      });

      // tl.to(document.querySelectorAll('#app > *'), {
      //   y: 0,
      //   duration: 0.8,
      //   ease: 'power3.inOut',
      //   clearProps: 'all'
      // }, 0);
    });
  },

  makeRequest(url, type) {
    const request = new XMLHttpRequest();

    console.log('Request: ', url, type);

    return new Promise(function (resolve, reject) {
      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status >= 200 && request.status < 300) {
            console.log('Request - done');
            resolve(request);
          } else {
            reject({
              status: request.status,
              statusText: request.statusText
            });
          }
        }
      };

      request.open('GET', url, true);
      request.responseType = type || '';
      request.send();
    });
  },

  checkDomain(url) {
    if (url.indexOf('//') === 0) {
      url = location.protocol + url;
    }

    return url.toLowerCase().replace(/([a-z])?:\/\//, '$1').split('/')[0];
  },

  isExternal(url) {
    return ((url.indexOf(':') > -1 || url.indexOf('//') > -1 )
      && this.checkDomain(location.href) !== this.checkDomain(url));
  },

  mapRange(value, inMin, inMax, outMin, outMax, clamp) {
    // Reference:
    // https://openframeworks.cc/documentation/math/ofMath/
    if (Math.abs(inMin - inMax) < Number.EPSILON) {
      return outMin;
    } else {
      let outVal = ((value - inMin) / (inMax - inMin) * (outMax - outMin) + outMin);
      if (clamp) {
        if (outMax < outMin) {
          if (outVal < outMax) outVal = outMax;
          else if (outVal > outMin) outVal = outMin;
        } else {
          if (outVal > outMax) outVal = outMax;
          else if (outVal < outMin) outVal = outMin;
        }
      }

      return outVal;
    }
  },

  evalScripts(code) {
    const script = document.createElement('script');
    script.type = 'text/javascript';

    try {
      script.appendChild(document.createTextNode(code));
    } catch (error) {
      script.text = code; //Old IE
    }

    document.head.insertBefore(script, document.head.firstChild);
    document.head.removeChild(script);
  }
};

Object.assign(transition, window.tangleweb);

export default transition;
